import style from './style.css';
import Button from 'preact-material-components/Button';

const CheckEligibleBtn = (props) => {
  const { btnTxt, btnClick, customStyle } = props;

  return (
    <Button
      className={`${style.checkEligibleBtn} ${customStyle &&
        style.checkEligibleBtnCustom}`}
      style={customStyle}
      onClick={() => btnClick()}>
      {btnTxt}
    </Button>
  );
};

export default CheckEligibleBtn;



// WEBPACK FOOTER //
// ./routes/campaign-activation/componentsVMerchant/checkEligibilityBtn/index.js